<template>
  <bm-dialog
    :label="title"
    :width="mergedOptions.width"
    :dialog-type="mergedOptions.type"
    :large="mergedOptions.large"
    @accept="emit('accept')"
    @cancel="emit('cancel')"
  >
    <v-row data-qa="info-dialog-content">
      <v-col cols="12">
        <span
          v-if="mergedOptions.isBodyHtml"
          :style="{
            whiteSpace: mergedOptions.preserveWhitespace
              ? 'pre-line'
              : 'normal',
          }"
          v-html="message"
        />
        <span
          v-else
          :style="{
            whiteSpace: mergedOptions.preserveWhitespace
              ? 'pre-line'
              : 'normal',
          }"
        >
          {{ message }}
        </span>
      </v-col>
    </v-row>

    <template #controls="props">
      <bm-dialog-controls
        v-bind="props"
        :cancelable="false"
        :large="mergedOptions.large"
        data-qa="info-dialog-controls"
      >
        <template #controls-confirm-text>
          {{ mergedOptions.customCloseButtonText || $m.ok }}
        </template>
      </bm-dialog-controls>
    </template>
  </bm-dialog>
</template>

<script setup lang="ts">
import BmDialog from "@/components/dialogs/BmDialog.vue";
import BmDialogControls from "@/components/dialogs/BmDialogControls.vue";
import { computed } from "vue";
import type { BmInformationDialogOptions } from "@/components/dialogs/DialogTypes";
import { EnumDialogType } from "@/components/dialogs/DialogTypes";

const defaultOptions: BmInformationDialogOptions = {
  type: EnumDialogType.info,
  width: 350,
  customCloseButtonText: "",
  large: false,
  preserveWhitespace: false,
  isBodyHtml: false,
};

interface BmInformationDialogProps {
  title?: string;
  message?: string;
  options?: Partial<BmInformationDialogOptions>;
}

const props = withDefaults(defineProps<BmInformationDialogProps>(), {
  title: "",
  message: "",
  options: () => ({}),
});

const emit = defineEmits<{
  (event: "accept"): void;
  (event: "cancel"): void;
}>();

const mergedOptions = computed(() => ({
  ...defaultOptions,
  ...props.options,
}));
</script>
